import { render, staticRenderFns } from "./SignatureIndicators.vue?vue&type=template&id=72f8f6a4&scoped=true"
import script from "./SignatureIndicators.vue?vue&type=script&lang=js"
export * from "./SignatureIndicators.vue?vue&type=script&lang=js"
import style0 from "./SignatureIndicators.vue?vue&type=style&index=0&id=72f8f6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f8f6a4",
  null
  
)

export default component.exports